module.exports = __webpack_public_path__ + "img/bgg3@3x.52e7082f.png";